import { render, staticRenderFns } from "./export-button.vue?vue&type=template&id=1f5736b0&scoped=true&"
import script from "./export-button.vue?vue&type=script&lang=ts&"
export * from "./export-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5736b0",
  null
  
)

export default component.exports